import { render } from "./TeacherSharePage.vue?vue&type=template&id=4ba8998b&scoped=true"
import script from "./TeacherSharePage.vue?vue&type=script&lang=js"
export * from "./TeacherSharePage.vue?vue&type=script&lang=js"

import "./TeacherSharePage.vue?vue&type=style&index=0&id=4ba8998b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ba8998b"]])

export default __exports__